module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hant_3-b53f323721f5c1a3c2840aa4d7aa8cb6.jpg";